<template>
  <div class="results-container">
    <h1 class="text-lg font-bold text-center" v-if="this.test && this.test === 'exams'">Exámen completado</h1>
    <h1 class="text-lg font-bold text-center" v-if="this.test && this.test === 'diagnosticTest'">Exámen diagnóstico completado</h1>
    <h1 class="text-lg font-bold text-center" v-if="this.test && this.test === 'simulacrums'">Simulacro completado</h1>
    <h1 class="text-lg font-bold text-center" v-if="this.test && this.test === 'practices'">Práctica completada</h1>

    <div class="text-neutral-700 mt-5 space-y-4">
      <p class="center-content text-center"
        v-if="this.test && (this.test === 'exams' || this.test === 'diagnosticTest')">
        Felicidades por finalizar tu exámen
      </p>
      <p class="center-content text-center" v-if="this.test && (this.test === 'practices' )">
        Felicidades por finalizar tu práctica
      </p>
      <p class="center-content text-center" v-if="this.test && this.test === 'simulacrums'">
        Felicidades por finalizar tu simulacro
      </p>
      
      <div v-if="this.seeResults()">
        <h1 class="text-lg font-bold text-center">Resultados</h1>

        <div v-if="this.test && (this.test === 'exams' || this.test === 'diagnosticTest') && !olympiadAdvancement">
          <h1 class="text-md text-center">
            {{
              this.passedByPoints
                ? 'Felicitaciones, has aprobado el exámen'
                : 'Lo sentimos, en esta ocasión no has aprobado el exámen'
            }}
          </h1>
        </div>

        <OlympiadExamOutcomeBanner
          v-if="olympiadAdvancement"
          :advancement="olympiadAdvancement"
          :slug="olympiadSlug"
          :olympic-id="olympiadId"
        />

        <div v-if="this.approved && this.finalPractice">
          <h1 class="text-md  text-center">¡Has Aprobado la práctica!</h1>
          <p class="text-center">Puedes continuar a la siguiente lección</p>
        </div>

        <div v-else-if="this.approved">
          <h1 class="text-md  text-center">¡Has Aprobado la práctica!</h1>
          <p class="text-center">Puedes saltar la lección si lo deseas</p>
        </div>

        <div v-else-if="this.finalPractice">
          <h1 class="text-md  text-center">No has Aprobado la práctica</h1>
          <p class="text-center">Puedes seguir repasando la lección para mejorar tus conocimientos</p>
        </div>

        <!-- Temporarily hidden: points/percentage details (show only pass/fail message for exams). -->
        <!--
        <div
          class="flex flex-row mt-5"
          v-if="!(this.test && (this.test === 'exams' || this.test === 'diagnosticTest'))"
        >
          <div class="basis-1/2">Puntos</div>
          <div class="basis-1/2 pb-3">
            <p class="text-right">{{ this.pointsEarned }} / {{ this.pointsTotal }}</p>
          </div>
        </div>

        <div
          class="flex flex-row mt-5"
          v-if="!(this.test && (this.test === 'exams' || this.test === 'diagnosticTest'))"
        >
          <div class="basis-1/2">Porcentaje</div>
          <div class="basis-1/2 pb-3">
            <p class="text-right">{{ this.percentage != null ? this.percentage.toFixed(2) : '0.00' }}%</p>
          </div>
        </div>
        -->
      </div>
    </div>

    <hr v-if="this.seeResults()">
    <br>

    <div v-if="this.seeResults() && !(this.test && (this.test === 'exams' || this.test === 'diagnosticTest'))">
      <div class="flex flex-row pb-4">
        <div class="basis-1/2">Ejercicios correctos</div>
        <div class="basis-1/2">
          <p class="text-right" v-if="this.results">{{this.results.generalResult.correct}}</p>
        </div>
      </div>
      <div class="flex flex-row">
        <div class="basis-1/2">Ejercicios incorrectos</div>
        <div class="basis-1/2">
          <p class="text-right" v-if="this.results">{{this.results.generalResult.incorrect}}</p>
        </div>
      </div>
    </div>

    <div class="flex justify-center items-center gap-3 pt-6 mt-4">
      <button class="mob-btn mob-cta-gold text-center" @click="startCourse"
        v-if="this.test && this.test !== 'lessons'">
        Continuar
      </button>

      <button class="mob-btn mob-cta-gold text-center" @click="skipLesson"
        v-if="this.test && this.test === 'lessons'">
        Ver leccion
      </button>

      <button 
        :class="[
          'mob-btn text-center',
          isPremiumUser ? 'mob-cta-gold' : 'mob-btn--premium-locked'
        ]" 
        @click="handleReviewClick"
        v-if="this.test && (this.test === 'simulacrums' || (this.test === 'exams' && this.exam.checkAnswers))">
        <Icon
          v-if="!isPremiumUser"
          icon="ph:crown" 
          :class="isPremiumUser ? '' : 'premium-icon-dark'"
        />
        Revisar
      </button>

      <button class="mob-btn mob-cta-gold-outline text-center ml-3" @click="startCourse"
        v-if="this.test && this.test === 'lessons' && approved && !finalPractice">
        <span>Saltar lección</span>
      </button>

      <button class="mob-btn mob-cta-gold-outline text-center ml-3" @click="startCourse"
        v-if="this.test && this.test === 'lessons' && finalPractice">
        Finalizar
      </button>
    </div>
    
    <MobPaymentModal ref="mobPaymentModal" />
  </div>
</template>

<script>
import { MobMessage } from "@/views/V2/components";
import { getResults } from "@/services/attemps.service";
import { getExam } from "@/services/exams.service";
import { Icon } from "@iconify/vue2";
import MobPaymentModal from "../payment-premium/PaymentModal.vue";
import OlympiadExamOutcomeBanner from "@/views/V2/olimpiadas/components/OlympiadExamOutcomeBanner.vue";
import { getOlympicBySlug } from "@/services/olympics.service";

export default {
  name: "ExerciseResults",
  
  components: {
    MobMessage,
    Icon,
    MobPaymentModal,
    OlympiadExamOutcomeBanner,
  },

  props:{
    moduleIdProp: String,
    originIdProp: String,
    testProp: String,
    questionsToApprove: [String, Number],
    finalPractice: Boolean
  },

  data() {
    return {
      results: null,
      percentage: null,
      approved: false,
      test: {},
      exam: {},
      pointsEarned: 0,
      pointsTotal: 0,
      passedByPoints: false,
      olympiadAdvancement: null,
      olympiadSlug: null,
      olympiadId: null,
    }
  },

  computed: {
    course() {      
      return this.$store.state.course.current;
    },
    isPremiumUser() {
      return this.$store.state.auth.isPremium;
    },
    isOlympiadCourse() {
      return !!(this.olympiadId || this.$store.state.course.olympic);
    },
  },

  async mounted() {
    // Si isPremium es null, obtener el estado premium del servidor
    if (this.isPremiumUser === null) {
      await this.$store.dispatch("auth/fetchPremiumStatus");
    }

    let moduleId = "";
    let originId = "";

    if (this.moduleIdProp && this.originIdProp && this.testProp ) {
      moduleId = this.moduleIdProp;
      originId = this.originIdProp;
      this.test = this.testProp;
    } else {
      moduleId = this.$route.params.id;
      originId = this.$route.params.originId;
      this.test = this.$route.params.test;
    }

     await this.getExam();

    if (this.seeResults()) {
      const raw = await getResults(this.test, originId, moduleId);
      if (typeof raw === "string") {
        try {
          this.results = JSON.parse(raw);
        } catch (e) {
          this.results = null;
        }
      } else {
        this.results = raw;
      }
      if (this.results?.olympiadAdvancement) {
        this.olympiadAdvancement = this.results.olympiadAdvancement;
      }
    }

    if (moduleId) {
      try {
        const { data } = await getOlympicBySlug("olimpiadas-mobius-2026");
        if (data && String(data.moduleId) === String(moduleId)) {
          this.olympiadSlug = data.slug;
          this.olympiadId = data.id;
        }
      } catch {
        /* not an olympiad module */
      }
    }

    if (this.results) {
      const correct = Number(this.results.generalResult.correct || 0);
      const incorrect = Number(this.results.generalResult.incorrect || 0);

      const points = this.results.points || {};
      this.pointsEarned = Number(points.earned || 0);
      this.pointsTotal = Number(points.total || 0);

      if (this.pointsTotal > 0) {
        this.percentage = (this.pointsEarned / this.pointsTotal) * 100;
      } else {
        const denom = correct + incorrect;
        this.percentage = denom > 0 ? (correct / denom) * 100 : 0;
      }

      if (this.test && (this.test === 'exams' || this.test === 'diagnosticTest')) {
        this.passedByPoints = this.pointsTotal > 0 ? (this.percentage >= 40.0) : false;
      }

      const requiredCorrect = this.questionsToApprove != null ? Number(this.questionsToApprove) : null;
      if (requiredCorrect != null) {
        if (correct >= requiredCorrect && this.test === 'lessons' ) {
          this.approved = true;
          this.$emit("markAsApproved")
        }
      } else {
        if (this.percentage > 70.0 && this.test === 'lessons' ) {
          this.approved = true;
          this.$emit("markAsApproved")
        }
      }
      this.$store.dispatch("dashboardCache/incrementExercisesCompleted");
    }
  },
  
  methods: {
    async getExam() {
      if (this.test && this.test === 'exams') {
        const examId = this.$route.params.originId;

        if (examId) {
          this.exam = await getExam(examId);
        }
      }
    },

    skipLesson () {
      this.$emit("skipLesson")
    },

    async startCourse() {
      const courseId = this.course?.id || this.$route.params.id;
      if (
        this.isOlympiadCourse &&
        this.test &&
        (this.test === "exams" || this.test === "simulacrums")
      ) {
        const slug = this.olympiadSlug || this.$store.state.course.olympic?.slug;
        this.$router.push({
          path: `/course/${courseId}/phases`,
          ...(slug ? { query: { slug } } : {}),
        });
        return;
      }
      if (this.test && this.test === 'exams')   this.$router.push(`/course/${this.course.id}/exams/intro`);
      if (this.test && this.test === 'simulacrums')   this.$router.push(`/course/${this.course.id}/simulacrums/intro`);
      if (this.test && this.test === 'diagnosticTest')   this.$router.push(`/course/${this.course.id}/introduction`);
      if (this.test && this.test === 'practices')   this.$router.push(`/course/${this.course.id}/practices/intro`);
      if (this.test && this.test === 'lessons')   this.$router.push(`/course/${this.course.id}/lessons/intro`);
      if (this.test && this.test === 'diagnosticTest'){
        this.$router.push(`/course/${this.course.id}/introduction`);
        this.$router.go();
      }
    },

    handleReviewClick() {
      if (!this.isPremiumUser) {
        this.$refs["mobPaymentModal"].showModalPayment();
        return;
      }
      this.reviewSimulacrum();
    },

    async reviewSimulacrum() {
      if (this.test && this.test === 'simulacrums') {
        this.$router.push(`/course/${this.course.id}/simulacrums/${this.$route.params.originId}/review`);
      } else if (this.test && this.test === 'exams')  {
        this.$router.push(`/course/${this.course.id}/exams/${this.$route.params.originId}/review`);
      }
    },

    seeResults() {
      return this.test && (this.test !== 'exams' || (this.test === 'exams' && this.exam.seeResult));
    },
  },
};
</script>
